import { Button } from '@liveauctioneers/hammer-ui-core/button';
import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { memo } from 'react';

import { useIsMobileLayout } from '@/hooks/useIsMobileLayout';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

type Props = {
    dismissModal: () => void;
    sellerName: string;
    uiError: boolean;
};

const SendSellerConsignmentMessageConfirmComponent = (props: Props) => {
    const { dismissModal, sellerName, uiError } = props;
    const formatMessage = useAppFormatMessage();
    const isMobile = useIsMobileLayout();

    const error = formatMessage(['we_experienced_a_server_error']);

    return (
        <BodyPrimary className="flex flex-col items-center pb-xl pt-md text-left">
            {uiError ? (
                <div className="max-[450px]:px-sm mb-lg px-2xl text-center">
                    {uiError && <span className="text-sm !text-text-critical">{error}</span>}
                </div>
            ) : (
                <div className="max-[450px]:px-sm mb-lg px-2xl text-center">
                    {formatMessage(['consignment_review_notice'], { values: { sellerName } })}
                </div>
            )}
            <div className="w-[calc(100%-64px)]">
                <Button
                    className={cn('mx-auto', isMobile ? 'w-full' : 'w-[264px]')}
                    onClick={dismissModal}
                >
                    {formatMessage(['keep_browsing'])}
                </Button>
            </div>
        </BodyPrimary>
    );
};

export const SendSellerConsignmentMessageConfirm = memo<Props>(SendSellerConsignmentMessageConfirmComponent);
